import queryString from '@framework/utils/queryString';

import { type Handler } from '../middleware';

export const LANGUAGE_PARAMETER = 'ui_locales';

const languageMiddleware: Handler<[], void> = (ctx) => {
    if (!ctx.req || !ctx.req.query) {
        return;
    }

    const { query } = ctx.req;

    if (query[LANGUAGE_PARAMETER]) {
        ctx.req.i18n?.changeLanguage(query[LANGUAGE_PARAMETER]);
        return;
    }

    if (query.next) {
        const parsedNextParameter = queryString.parse(query.next);
        if (parsedNextParameter[LANGUAGE_PARAMETER]) {
            const languageParamInNext = parsedNextParameter[LANGUAGE_PARAMETER];

            /**
             * There is a chance that the OIDC client sends an array of language code string
             * in that case we need to get the first entry only.
             */
            if (typeof languageParamInNext === 'string') {
                ctx.req.i18n?.changeLanguage(languageParamInNext);
            } else if (Array.isArray(languageParamInNext)) {
                ctx.req.i18n?.changeLanguage(languageParamInNext[0]);
            }
        }
    }
};

export default languageMiddleware;
